import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiTab"] = {
  root: {
    "&.Mui-selected": {
      color: "#6d9c15 !important",
    },
  },
};

const StyledTab = {
  styleOverrides,
};

export default StyledTab;
